var _path, _path2, _ellipse, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotFound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  className: "not_found_svg__point_svg",
  viewBox: "0 0 122 143"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#not_found_svg__a)",
  strokeWidth: 12,
  d: "M115.336 58.613c0 20.06-12.091 36.822-26.094 50.474-6.476 6.314-13.122 11.737-18.849 16.412l-1.217.993c-2.949 2.41-5.7 4.679-7.911 6.711q-.252.232-.506.469c-2.679-2.424-5.846-4.968-9.066-7.557l-.724-.582c-6.16-4.952-13.149-10.591-19.795-17.169-13.346-13.207-24.51-29.42-24.51-49.751C6.664 29.718 30.826 6 61 6s54.336 23.718 54.336 52.613Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#not_found_svg__b)",
  strokeWidth: 12,
  d: "M108.725 59.763c0 15.96-10.772 31.057-23.662 43.808-6.316 6.248-12.839 11.644-18.254 16.041q-.811.66-1.598 1.296c-2.056 1.666-3.953 3.203-5.52 4.535l-.037.031c-2.37-2.206-5.058-4.525-7.815-6.903l-1.481-1.279c-5.363-4.635-11.182-9.752-16.628-15.531-10.941-11.61-19.724-25.218-20.17-41.587-.762-27.926 20.05-47.278 47.438-47.278 27.164 0 47.727 21.163 47.727 46.867Z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 61,
  cy: 58.614,
  fill: "url(#not_found_svg__c)",
  rx: 16.664,
  ry: 16.665
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60.998,
  cy: 58.616,
  r: 8.045,
  fill: "url(#not_found_svg__d)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "not_found_svg__a",
  x1: 61,
  x2: 61,
  y1: 21.836,
  y2: 152.566,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#78B9F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#417CF6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not_found_svg__b",
  x1: 61.002,
  x2: 61.002,
  y1: 23.273,
  y2: 154.865,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#448EF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#67B2F7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not_found_svg__c",
  x1: 61,
  x2: 61,
  y1: 41.949,
  y2: 75.278,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#55A9F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3975F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "not_found_svg__d",
  x1: 60.998,
  x2: 60.998,
  y1: 50.571,
  y2: 66.661,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#448EF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#448EF7"
})))));
export default SvgNotFound;